export default "__VITE_ASSET__8b260135__"